import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
declare let getSecData: any;

@Component({
  selector: 'app-smx-sec-filings',
  templateUrl: './smx-sec-filings.component.html',
  styleUrls: ['./smx-sec-filings.component.css']
})
export class SmxSecFilingsComponent implements OnInit {

  constructor(public router: Router) {    
    getSecData();
  }

  ngOnInit(): void {
    document.documentElement.style.setProperty(
      "--color",
      !(this.router.url === "/home" || this.router.url === "/")
        ? "black"
        : "white"
    );
    
  }

}
